module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4NmJjYzRiOWFkMzBhZTQzMzhmNTBhOGQ0NWUwYjk5ZS5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icons/turn-arrow.svg
// module id = 215
// module chunks = 0